module.exports = __webpack_public_path__ + "assets/img/mecha-btn-352b4a67.png";